import { useCallback, useEffect, useState } from "react";

import api from "@helpers/api";

import { DEFAULT_EXPORT_FIELDS, DEFAULT_EXPORT_FORMAT } from "../enums";

const SUCCESS_MESSAGE =
  "A exportação está em andamento, você receberá um email com a lista de membros assim que o processamento for concluído";

const EMPTY_FILTERS = {
  roles: [],
  plan_ids: [],
  subscription_statuses: [],
};

export default function useExportMembers({ communityId, open, filtersSnapshot }) {
  const [format, setFormat] = useState(DEFAULT_EXPORT_FORMAT);
  const [fields, setFields] = useState(DEFAULT_EXPORT_FIELDS);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (!open) return;
    setFormat(DEFAULT_EXPORT_FORMAT);
    setFields(DEFAULT_EXPORT_FIELDS);
    setSubmitting(false);
  }, [open]);

  const toggleField = useCallback((fieldId, enabled) => {
    setFields((prev) => {
      const set = new Set(prev);
      if (enabled) set.add(fieldId);
      else set.delete(fieldId);
      return Array.from(set);
    });
  }, []);

  const submit = useCallback(
    async (onSuccess) => {
      if (!communityId || !fields.length || submitting) return false;

      const snapshot = filtersSnapshot || {};
      const snapshotFilters = snapshot.filters || EMPTY_FILTERS;

      const payload = {
        format,
        fields,
      };

      const filters = {};
      if (snapshot.search && snapshot.search.trim().length >= 2) {
        filters.search = snapshot.search.trim();
      }
      if (snapshotFilters.roles?.length) filters.roles = snapshotFilters.roles;
      if (snapshotFilters.plan_ids?.length) filters.plan_ids = snapshotFilters.plan_ids;
      if (snapshotFilters.subscription_statuses?.length) {
        filters.subscription_statuses = snapshotFilters.subscription_statuses;
      }
      if (Object.keys(filters).length) payload.filters = filters;

      setSubmitting(true);
      try {
        await api.post(`community/${communityId}/members/export`, payload);
        window.setSnackbar?.(SUCCESS_MESSAGE);
        if (onSuccess) onSuccess();
        return true;
      } catch (error) {
        console.error("Failed to export members", error);
        window.setSnackbar?.("Não foi possível iniciar a exportação");
        return false;
      } finally {
        setSubmitting(false);
      }
    },
    [communityId, format, fields, submitting, filtersSnapshot]
  );

  return {
    format,
    setFormat,
    fields,
    toggleField,
    submitting,
    submit,
    canSubmit: fields.length > 0 && !!communityId,
  };
}
